module.exports = __webpack_public_path__ + "img/calculator.f1ba5509.svg";